import clsx from "clsx";
import PropTypes from "prop-types";
import "./radio-button.scss";

export const Radio = ({ className = "", label, onChange, ...props }) => {
  // Matching the semantic-ui-react API for onChange so we can swap
  // out their component with ours easily
  const handleChange = (e) => {
    onChange(e, { ...props, label, checked: e.target.checked });
  };

  const input = (
    <input
      {...props}
      className={clsx("ha-radio-button", className)}
      onChange={handleChange}
      type="radio"
    />
  );

  if (label === undefined || label === null) return input;

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className="ha-radio-label">
      {input}
      <span>{label}</span>
    </label>
  );
};

Radio.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  onChange: PropTypes.func.isRequired,
};
